import styled from 'styled-components';

type StyledGridSizeProps = { $editLayoutWidthStyle: string; $backgroundColor: string; $isLayoutEmpty?: boolean };

const StyledGridSize = styled.div<StyledGridSizeProps>`
    padding: 24px;
    height: 100%;
    overflow-y: ${({ $isLayoutEmpty }) => ($isLayoutEmpty ? 'invisible' : 'scroll')};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    margin: auto;
    width: ${({ $editLayoutWidthStyle }) => $editLayoutWidthStyle};
    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px,
        rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
`;

export default StyledGridSize;
